<template>
    <div class="card-pedidos-expedidos-faturados-fluxo"> 
        <g-tab-menu :items="items">
            
        </g-tab-menu>     
    </div>
</template>

<script>
import ExpedidosFaturadosFluxo from './ExpedidosFaturadosFluxo.js';
export default ExpedidosFaturadosFluxo
</script>

<style scoped>

</style>